import { __awaiter } from "tslib";
import { useEffect, useRef, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { I18N_NAMESPACES } from '../../../constants/i18nConstants';
import { getDeliveryAddressValidationSchema } from './DeliveryForm.utils';
import { hasPrefilledAddress } from '../../form/address-fields/addressFields.utils';
export const useValidateAddress = ({ address, country, trigger, shouldValidate = true, isFormActive, }) => {
    const { t } = useTranslation(I18N_NAMESPACES.checkout);
    const [isValidAddress, setIsValidAddress] = useState(true);
    const shouldValidateRef = useRef(shouldValidate);
    useEffect(() => {
        if (!hasPrefilledAddress(address)) {
            setIsValidAddress(false);
            shouldValidateRef.current = true;
            return;
        }
        const validateForm = () => __awaiter(void 0, void 0, void 0, function* () {
            const isValid = yield getDeliveryAddressValidationSchema({ t, country }).isValid(address);
            setIsValidAddress(isValid);
            if (!isValid) {
                yield trigger('customer.address');
                shouldValidateRef.current = false;
            }
        });
        if (address && shouldValidateRef.current) {
            validateForm();
        }
    }, [address, country, shouldValidate, isFormActive]);
    return { isValidAddress };
};
